var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"a-input-text"},[_c('input',{ref:"input",staticClass:"a-input-text__body",attrs:{"type":"text","placeholder":_vm.placeholder,"maxlength":_vm.maxLength},domProps:{"value":_vm.value},on:{"input":_vm.updateValue}})])}
var staticRenderFns = []

export { render, staticRenderFns }